// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608282001/js/" + chunkId + "." + {"44":"5d59db4c","225":"d43728b3","481":"d75dd127","486":"33b63976","770":"d84d3d1d"}[chunkId] + ".0.6916174838109729.chunk.js";
};